module.exports = __webpack_public_path__ + "static/img/BRADY-HALL.b10350e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/BRADY-HALL.jpg
// module id = HC1v
// module chunks = 0